import {Injectable} from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions,BrowserXhr} from '@angular/http';

import { StorageService } from './storage.service';
import { PageNavigationService } from './page-navigation.service';

enum FlowState { inactive, selected, active }

@Injectable()
export class LayoutService {
    currentPage: string;
    headerType: string;
    headerTitle: string = 'Mobil 88';
    isLogout: number;//Kowsalya
    isPaymentAgreed: number;//Kowsalya
    tandc: boolean;

    vHeader = {
        home: false,
        PPM: false,
        PNCEA: false,
        userAccount: false,
        createAccount: false,
        plantmaps: false,
        NCEA: false,
        faq: true,
        contactUs: false,
        profileStatus: false,
        login: false,
        register: false
    }

    vSubHeaderItem = {
        home: false,
        PPM: false,
        PNCEA: false,
        userAccount: false,
        createAccount: false,
        plantmaps: false,
        NCEA: false
    };
    
    vPlantmapFlow:Array<string> = [
        "plantmap-earthwork-details",
        "plantmap-area-of-interest",
        "plantmap-upload-document",
        "plantmap-payment",
        "plantmap-confirmation"
    ];

    vNCEFlow:Array<string> = [
        "nce-fill-in-particulars",
        "nce-earthwork-details",
        "nce-upload-attachment",
        "nce-declaration",
        "nce-preview",
        "nce-payment",
        "nce-briefing-document",
        "nce-briefing-session",
        "nce-appointment-upload",
        "nce-appointment-document",
        "nce-make-appointment",
        "nce-apply-for-final-approval",
        "nce-final-approval"
    ];
    
    vLayoutState = {
        appHeader: false,
        appSubHeader: false,
        appPPMFlowHeader: false,
        appNCEApplicationFlowHeader: false,
    };

    vNCECurrentState:number = 0;
    vPlantmapCurrentState:number = 0;

    nullStatus = false;
    nullLayoutMsg = '';

    constructor (
        private _pageNavigationService:PageNavigationService,
        private _storageService: StorageService,
        private _http: Http
    ) {
        if(this.currentPage === null||this.currentPage === undefined) {
           this.currentPage = 'authorize';
           this.headerType='1';
        }else {
            this.currentPage = this.currentPage;
            this.headerType=this.headerType;
        }

    }
    
    setNullMsg(nullMsg:string) {
        this.nullLayoutMsg = nullMsg;
    }
    
    resetNullStatus() {
        this.nullLayoutMsg = '';
        this.nullStatus=false;
    }

    // resetHeaderState() {
    // }

    resetSubHeaderState(){
        this.vSubHeaderItem = {
            home: false,
            PPM: false,
            PNCEA: false,
            userAccount: false,
            createAccount: false,
            plantmaps: false,
            NCEA: false
        };
    }

    resetHeaderState(){
        this.vHeader = {
            home: false,
            PPM: false,
            PNCEA: false,
            userAccount: false,
            createAccount: false,
            plantmaps: false,
            NCEA: false,
            contactUs: false,
            faq: false,
            login: false,
            profileStatus: false,
            register: false
        };
    }

    setCurrentPage(current:string) {
        // this.resetHeaderState();

        this.currentPage = current;

        this.resetSubHeaderState();
        this.resetHeaderState();
        
        var access;
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }
        
        if(this.currentPage === 'login-change-password' || this.currentPage === 'login-registration-confirmation' 
        || this.currentPage === 'login-set-new-password'){
            
        }else if(access === null){
            this.vHeader.faq = true;
            this.vHeader.contactUs = true;  
            
            if(this.currentPage === 'login-login'){
                this.vHeader.register = true;
            }else if(this.currentPage === 'login-register'){
                this.vHeader.login = true;
            }else{
                this.vHeader.register = true;
                this.vHeader.login = true;
            }
        }else if( this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access) ){ // customer
            this.vHeader.home = true;
            this.vHeader.PPM = true;
            this.vHeader.PNCEA = true;
            this.vHeader.profileStatus = true;
        }else if(this.actionChecking('MANPL', access) && this.actionChecking('MANINU', access) && this.actionChecking('MANEXU', access)){ // PLAD
            this.vHeader.userAccount = true;
            this.vHeader.plantmaps = true;
            this.vHeader.createAccount = true;
            this.vHeader.profileStatus = true;
        }else if(this.actionChecking('MANINU', access) && this.actionChecking('MANEXU', access)){ // ADMN
            this.vHeader.userAccount = true;
            this.vHeader.createAccount = true;
            this.vHeader.profileStatus = true;
        }else if(this.actionChecking('MANINU', access) && this.actionChecking('MANNCE', access)){ // NCEA
            this.vHeader.userAccount = true;
            this.vHeader.NCEA = true;
            this.vHeader.createAccount = true;
            this.vHeader.profileStatus = true;
        }else if(this.actionChecking('MANPL', access)){ // PLOP
            this.vHeader.plantmaps = true;
            this.vHeader.profileStatus = true;
        }else if(this.actionChecking('MANNCE', access)){ // NCEO
            this.vHeader.NCEA = true;
            this.vHeader.profileStatus = true;
        }

        if(this.vPlantmapFlow.some(x => x === current)) {
            this.vLayoutState.appPPMFlowHeader = true;
            this.vPlantmapCurrentState = this.vPlantmapFlow.indexOf(current);
        } else {
            this.vLayoutState.appPPMFlowHeader = false;
        }
        if(this.vNCEFlow.some(x => x === current)) {
            this.vLayoutState.appNCEApplicationFlowHeader = true;
            this.vNCECurrentState = this.vNCEFlow.indexOf(current);
        } else {
            this.vLayoutState.appNCEApplicationFlowHeader = false;
        }
        
        this._pageNavigationService.setCurrentPage(current);
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }

    getLayoutState () {
        return this.vLayoutState;
    }
    
    getCurrentPage() {
		return this.currentPage;
	}
 
    getHeaderType() {
        return this.headerType;
    } 

    getHeaderTitle() {
        return this.headerTitle;
    }

    getNCEStateFromName(name:string) {
        return this.vNCEFlow.indexOf(name);
    }

    getNCECurrentState() {
        return this.vNCECurrentState;
    }

    getPlantmapStateFromName(name:string) {
        return this.vPlantmapFlow.indexOf(name);
    }

    getPlantmapCurrentState() {
        return this.vPlantmapCurrentState;
    }

    isRestrictedArea(){
        let data = this._storageService.getSessionItem('plantMapAreaInterest');
        if(data !== null) {
            let parsedData = JSON.parse(data);
            if(parsedData.restricted_area == 1) {
                return true;
            }
            else {
                return false;
            }

        }else {
            return false;
        }
    }

    isExtensionNCE(){
        if(this.getCurrentPage() === 'nce-make-appointment' || this.getCurrentPage() == 'nce-briefing-session'){
            return false;
        }
        let data = this._storageService.getSessionItem('extensionNCE');
        if(data !== null) {
            if(data === '1') {
                return true;
            }
            else {
                return false;
            }

        }else {
            return false;
        }
    }

    /*isSubHeaderItemActive(item:string) {
        if(!this.vLayoutState.appSubHeader || this.vSubHeaderActive[this.currentPage] == null) {
            return false;
        } else if(this.vSubHeaderActive[this.currentPage].active == item) {
            return true;
        } else {
            return false;
        }
    }*/

    setNCEFlow(pCurrent){
        if(this.vNCEFlow.some(x => x === pCurrent)) {
            this.vLayoutState.appNCEApplicationFlowHeader = true;
            this.vNCECurrentState = this.vNCEFlow.indexOf(pCurrent);
        } else {
            this.vLayoutState.appNCEApplicationFlowHeader = false;
        }
    }

    isHeaderItemShow(item:string) {
        if(!this.vLayoutState.appHeader || this.vHeader[this.currentPage] == null) {
            return false;
        } else if(this.vHeader[this.currentPage].some(x => x === item)) {
            return true;
        } else {
            return false;
        }
    }

    scrollTo(element, to, duration) {
        if (duration <= 0) return;
        var difference = to - element.scrollTop;
        var perTick = difference / duration * 30;

        setTimeout(() => {
            var value = element.scrollTop + perTick;
            window.scroll(0, value);
            if (element.scrollTop === to) return;
            this.scrollTo(element, to, duration - 30);
        }, 30);
    } 
    
    scrollToTopContainer(to, duration) {
        let container = document.getElementById(to);
        
        if(container !== undefined) {
            let position = container.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
            
            // console.log("tes scroll : " + to);
            // 45 is the height of header
            this.scrollTo(document.body, position - 60 , duration);
        }
    }  

    scrollToWithTimeout(to, duration, timeout) {
         setTimeout(() => {
             this.scrollToTopContainer(to, duration);
         }, timeout);
    }
}




// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/layout.service.ts